/** Registers the PanelContainer parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parsePanelContainer } from './parser';
const panelContainerRegistration = {
    typeName: 'PanelContainer',
    parser: parsePanelContainer,
};
nodeRegistry.register(panelContainerRegistration);
export * from './parser';
//# sourceMappingURL=index.js.map